import React, { useEffect, useState } from 'react';
import { useSubscriptionRenewal } from '../../../context/SubscriptionRenewalContext.jsx';
import RenewSubscriptionModal from '../../../components/Subscription/RenewSubscriptionModal.jsx';
import { useNavigate } from 'react-router-dom';

const ExpiredSubscriptionScreen = () => {
    const { subscriptionData, openRenewPackageModal, isModalOpen } = useSubscriptionRenewal();
    const navigate = useNavigate();
    const role = localStorage.getItem('role');

    useEffect(() => {
        if (role === 'SuperAdmin' || role === 'SelfAdmin') {
            navigate('/dashboard');
        }
    }, [role, navigate]);

    return (
        <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', height: '100vh', backgroundColor: '#f9fafb', padding: '20px'
        }}>
            <div style={{
                maxWidth: '500px', width: '100%', backgroundColor: '#fff',
                padding: '40px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                textAlign: 'center', borderTop: '6px solid #dc2626'
            }}>
                <div style={{ marginBottom: '20px', color: '#dc2626' }}>
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                </div>
                <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#111827', marginBottom: '16px' }}>
                    Subscription Expired
                </h1>
                <p style={{ color: '#4b5563', fontSize: '15px', marginBottom: '24px', lineHeight: '1.5' }}>
                    Your Store subscription has expired. Please renew your package to continue using the TVFM POS application and accessing your store data.
                </p>

                {subscriptionData && (
                    <div style={{
                        backgroundColor: '#f3f4f6', padding: '15px', borderRadius: '8px',
                        marginBottom: '24px', textAlign: 'left', fontSize: '14px', color: '#374151'
                    }}>
                        <div style={{ marginBottom: '8px' }}>
                            <strong>Store Name:</strong> {subscriptionData.storeName || 'N/A'}
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            <strong>Previous Package:</strong> {subscriptionData.packageName || 'N/A'}
                        </div>
                        <div>
                            <strong>Expired Date:</strong> {
                                subscriptionData.finalExpiryDate
                                    ? new Date(subscriptionData.finalExpiryDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
                                    : 'N/A'
                            }
                        </div>
                    </div>
                )}

                <button
                    onClick={() => openRenewPackageModal()}
                    style={{
                        backgroundColor: '#dc2626', color: '#fff', border: 'none',
                        padding: '12px 24px', fontSize: '16px', fontWeight: '600',
                        borderRadius: '6px', cursor: 'pointer', width: '100%',
                        transition: 'background-color 0.2s'
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#b91c1c'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#dc2626'}
                >
                    Select Package & Renew
                </button>
                
                <button
                    onClick={() => {
                        localStorage.clear();
                        navigate('/login');
                    }}
                    style={{
                        marginTop: '16px', background: 'transparent', color: '#4b5563',
                        border: 'none', cursor: 'pointer', textDecoration: 'underline'
                    }}
                >
                    Logout
                </button>
            </div>
            {isModalOpen && <RenewSubscriptionModal />}
        </div>
    );
};

export default ExpiredSubscriptionScreen;
